/* eslint-plugin-disable angular */

/**
 * Common webpack parts
 * @param appConfig
 * @returns {{output: {path: string, filename: string},
 * entry: {main: string},
 * resolve: {alias: {assets: string, wc: string},
 * modules: string[]},
 * plugins: *[],
 * module: {rules: *[]}}}
 */
function webpackCommon(appConfig) {
    return {
        entry: {
            main: appConfig.modules.path.join(appConfig.dirName + '/src/index.js')
        },
        output: {
            path: appConfig.modules.path.resolve(appConfig.dirName + '/dist'),
            filename: '[name].[hash:8].js',
            publicPath: ''
        },
        resolve: {
            alias: {
                assets: appConfig.modules.path.resolve(appConfig.dirName + '/src/assets'),
                images: appConfig.modules.path.resolve(appConfig.dirName + '/src/images'),
                moment: appConfig.modules.path.resolve(appConfig.dirName + '/node_modules/moment/moment.js'),
                lodash: appConfig.modules.path.resolve(appConfig.dirName + '/node_modules/lodash/dist/lodash.compat'),
                'angular-fr': appConfig.modules.path.resolve(appConfig.dirName + '/node_modules/angular-i18n/angular-locale_fr-fr')
            },
            modules: [
                appConfig.modules.path.resolve(appConfig.dirName + '/src'),
                'node_modules'
            ]
        },
        module: {
            rules: [
                // Image handle
                {
                    test: /\.(png|jpg|jpeg|gif)$/,
                    loader: 'file-loader',
                    options: {
                        name: '[name].[hash:8].[ext]',
                        outputPath: 'images/'
                    }
                },
                // Fonts handle
                {
                    test: /\.(woff|woff2|eot|ttf|svg)$/,
                    loader: 'file-loader',
                    options: {
                        name: '[name].[hash:8].[ext]',
                        outputPath: 'assets/fonts/'
                    }
                },
                // pdf handle
                {
                    test: /\.pdf$/,
                    loader: 'file-loader',
                    options: {
                        name: '[name].[hash:8].[ext]',
                        outputPath: 'files/'
                    }
                },
                // JS Handle
                {
                    test: /\.js$/,
                    exclude: /node_modules/,
                    use: [
                        {
                            loader: 'ng-annotate-loader'
                        },
                        {
                            loader: 'eslint-loader',
                            options: {
                                quiet: true
                            }
                        }
                    ]
                },
                {
                    test: /\.(html)$/,
                    loader: 'html-loader'
                }
            ]
        },
        plugins: [
            // Generates default index.html
            new appConfig.modules.HtmlWebpackPlugin({
                template: 'src/index.html'
            }),
            new appConfig.modules.CopyWebpackPlugin([
                {
                    context: appConfig.dirName + '/src/modules/**/**/partials',
                    from: appConfig.dirName + '/src/modules/**/**/partials/**/*.html',
                    to: appConfig.dirName + '/dist/modules/**/partials'
                },
                {
                    context: appConfig.dirName + '/src/images',
                    from: appConfig.dirName + '/src/images/*',
                    to: appConfig.dirName + '/dist/images'
                },
                {
                    context: appConfig.dirName + '/src/files',
                    from: appConfig.dirName + '/src/files/*.pdf',
                    to: appConfig.dirName + '/dist/files'
                }
            ]),
            new appConfig.modules.webpack.DefinePlugin({
                'process.version': JSON.stringify(appConfig.modules.pckg.version),
                'process.env.NODE_ENV': JSON.stringify(process.env.NODE_ENV || 'development')
            }),
            // https://github.com/jmblog/how-to-optimize-momentjs-with-webpack
            new appConfig.modules.webpack.ContextReplacementPlugin(/moment[/\\]locale$/, /fr/)
        ]
    };
}

/**
 * Webpack development default options
 * @param appConfig
 * @returns {{mode: string,
 * devtool: string,
 * devServer: {overlay: boolean, port: number, host: string,
 * progress: boolean, quiet: *, hot: boolean, watchContentBase: boolean, open: boolean, contentBase: string},
 * plugins: *[],
 * module: {rules: *[]}}}
 */
function webpackDefaultDev(appConfig) {
    return {
        mode: 'development',
        devtool: 'cheap-module-eval-source-map',
        devServer: {
            contentBase: appConfig.modules.path.resolve(appConfig.dirName + '/dist'),
            open: false,
            overlay: true,
            port: 3800,
            progress: true,
            quiet: appConfig.isDevQuiet,
            host: '0.0.0.0',
            hot: true,
            watchContentBase: true
        },
        module: {
            rules: [
                // CSS Handle
                {
                    test: /\.css$/,
                    use: ['style-loader', 'css-loader']
                },
                // LESS Handle
                {
                    test: /\.less$/,
                    use: [
                        {
                            loader: 'style-loader',
                            options: {
                                sourceMap: true
                            }
                        },
                        {
                            loader: 'css-loader',
                            options: {
                                importLoaders: 1,
                                sourceMap: true
                            }
                        },
                        {
                            loader: 'postcss-loader',
                            options: {
                                config: {
                                    path: __dirname + '/postcss.config.js'
                                },
                                sourceMap: true
                            }
                        },
                        {
                            loader: 'less-loader',
                            options: {
                                javascriptEnabled: true,
                                sourceMap: false
                            }
                        }
                    ]
                }
            ]
        },
        plugins: [
            new appConfig.modules.webpack.HotModuleReplacementPlugin(),
            new appConfig.modules.FriendlyErrorsWebpackPlugin(), // friendly console messages
            new appConfig.modules.CopyWebpackPlugin([
                {
                    context: appConfig.dirName + '/bouchons',
                    from: appConfig.dirName + '/bouchons/*.json',
                    to: appConfig.dirName + '/dist/bouchons/'
                }
            ]) // ,
            // new appConfig.modules.ServiceWorkerWebpackPlugin({
            //     entry: appConfig.modules.path.join(appConfig.dirName, 'src/sw.js')
            // })
        ]
    };
}

/**
 * Webpack production / build options
 * @returns {{mode: string, devtool: string,
 * optimization: {noEmitOnErrors: boolean, minimizer: *[], splitChunks: {chunks: string}},
 * plugins: *[],
 * module: {rules: *[]}}}
 */
function webpackDefaultProd(appConfig) {
    return {
        mode: 'production',
        devtool: 'source-map',
        module: {
            rules: [
                // CSS Handle
                {
                    test: /\.css$/,
                    use: ['style-loader', appConfig.modules.MiniCssExtractPlugin.loader, 'css-loader']
                },
                // LESS Handle
                {
                    test: /\.less$/,
                    use: [
                        'style-loader',
                        appConfig.modules.MiniCssExtractPlugin.loader,
                        {
                            loader: 'css-loader',
                            options: {
                                importLoaders: 1
                            }
                        },
                        {
                            loader: 'postcss-loader',
                            options: {
                                config: {
                                    path: __dirname + '/postcss.config.js'
                                }
                            }
                        },
                        {
                            loader: 'less-loader',
                            options: {
                                javascriptEnabled: true,
                                sourceMap: false
                            }
                        }
                    ]
                }
            ]
        },
        plugins: [
            // new BundleAnalyzerPlugin(),
            // Generates favicons
            // new appConfig.modules.FaviconsWebpackPlugin({
            //     logo: __dirname + '/src/images/logo_bimedia_large.png',
            //     prefix: '',
            //     icons: {
            //         android: true,
            //         appleIcon: true,
            //         appleStartup: true,
            //         coast: false,
            //         favicons: true,
            //         firefox: true,
            //         opengraph: false,
            //         twitter: false,
            //         yandex: false,
            //         windows: false
            //     }
            // }),
            new appConfig.modules.NgAnnotatePlugin({
                add: true
            }),
            // extract css to external file when production
            new appConfig.modules.MiniCssExtractPlugin({
                filename: '[name].[contenthash:8].css',
                chunkFilename: '[name].[id].css'
            }),
            // new appConfig.modules.ServiceWorkerWebpackPlugin({
            //     entry: appConfig.modules.path.join(appConfig.dirName, 'src/sw.js'),
            //     publicPath: '/bdc/'
            // }),
            // clean dist folder for every build
            new appConfig.modules.CleanWebpackPlugin()
        ],
        optimization: {
            noEmitOnErrors: true,
            minimizer: [
                new appConfig.modules.CompressionPlugin({
                    algorithm: 'gzip'
                }),
                new appConfig.modules.TerserPlugin(),
                new appConfig.modules.OptimizeCSSAssetsPlugin({})
            ],
            splitChunks: {
                chunks: 'all'
            }
        }
    };
}

module.exports.webpackCommon = webpackCommon;
module.exports.webpackDefaultDev = webpackDefaultDev;
module.exports.webpackDefaultProd = webpackDefaultProd;
